import React from 'react';
import './IconInput.scss';

const IconInput = ({ icon,type='text',onChange,placeholder,className="" }) => {
  return (
    <div className={`icon-input-wrapper ${className?className:""}`}>
      <img className="icon" src={icon}></img>
      <input type={type} className="icon-input" onChange={onChange}placeholder={placeholder} />
    </div>
  );
};
export default IconInput